import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { orderCategoryDetail, orderExceptionCategoryDetail, categoryRegion } from '@/views/platformReport/api/index.js';
export default {
  props: {
    /**
     * entry 入口类型
     * platformReport - 平台报表-订单消费统计
     * abnormalOrderMonitor - 平台报表-异常订单监控
     * orderListDetail - 订单列表-订单详情
    */
    entry: {
      type: String,
      default: function _default() {
        return 'platformReport';
      }
    },
    /**
     * originParams 原始参数
    */
    originParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      tabsName: '1',
      tabsConfig: [{
        name: '1',
        label: '省份明细',
        tips: '以用户购买电影服务所在省份为单位汇总统计通过当前菜单生成的订单数、座位数、消费点数、成本、成本率'
      }, {
        name: '2',
        label: '城市明细',
        tips: '以用户购买电影服务所在城市为单位汇总统计通过当前菜单生成的订单数、座位数、消费点数、成本、成本率'
      }],
      headerCellStyle: {
        background: '#F1F1F1',
        color: '#333333'
      },
      filter: {
        province_code: '',
        city_code: ''
      },
      provinceOptions: [],
      cityOptions: [],
      searchedWithCateName: false,
      list: [],
      pages: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      }
    };
  },
  mounted: function mounted() {
    this.handleResetData();
    this.handleGetRegionList();
    this.handleGetDetailList();
  },
  methods: {
    onChangeProvinceCode: function onChangeProvinceCode(val) {
      this.cityOptions = [];
      this.filter.city_code = '';
      this.filter.province_code = val || '';
      if (this.filter.province_code) {
        this.handleGetRegionList();
      }
    },
    handleGetRegionList: function handleGetRegionList() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var params, _yield$categoryRegion, _yield$categoryRegion2, data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = {
                province_id: _this.filter.province_code
              };
              _context.n = 1;
              return categoryRegion(params);
            case 1:
              _yield$categoryRegion = _context.v;
              _yield$categoryRegion2 = _yield$categoryRegion.data;
              data = _yield$categoryRegion2 === void 0 ? {} : _yield$categoryRegion2;
              _this.provinceOptions = (data === null || data === void 0 ? void 0 : data.provinces) || [];
              _this.cityOptions = (data === null || data === void 0 ? void 0 : data.cities) || [];
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.error(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2]]);
      }))();
    },
    rowStyle: function rowStyle(_ref) {
      var row = _ref.row,
        rowIndex = _ref.rowIndex;
      var keywords = ['合计', '总计'];
      if (rowIndex === 0 && keywords.includes(row.province_name)) {
        return {
          fontWeight: 'bold',
          color: '#000'
        };
      } else {
        return {};
      }
    },
    handleResetData: function handleResetData() {
      this.tabsName = '1';
      this.cityOptions = [];
      this.provinceOptions = [];
      this.filter.province_code = '';
      this.filter.city_code = '';
      this.searchedWithCateName = false;
      this.pages.page = 1;
      this.pages.pagesize = 50;
      this.pages.totalCount = 0;
      this.list = [];
    },
    handleClickTab: function handleClickTab(tab) {
      if (tab.name === '1') {
        this.pages.page = 1;
        this.list = [];
        this.handleGetDetailList();
      } else if (tab.name === '2') {
        this.pages.page = 1;
        this.list = [];
        this.handleGetDetailList();
      }
    },
    onClickProvinceName: function onClickProvinceName(row) {
      this.onChangeProvinceCode(row.province_code);
      this.tabsName = '2';
      this.handleClickTab({
        name: '2'
      });
    },
    handleGetDetailList: function handleGetDetailList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (_this2.entry === 'platformReport') {
                // 平台报表-订单消费统计
                _this2.getPlatformList();
              } else if (_this2.entry === 'abnormalOrderMonitor') {
                // 异常订单监控
                _this2.getAbnormalList();
              } else if (_this2.entry === 'orderListDetail') {
                // 订单列表-订单详情
                _this2.getOrderListDetailList();
              }
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    handlePageChange: function handlePageChange(page) {
      this.pages.page = page;
      this.handleGetDetailList();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.pages.pagesize = size;
      this.pages.page = 1;
      this.handleGetDetailList();
    },
    onClickSearch: function onClickSearch() {
      this.pages.page = 1;
      this.handleGetDetailList();
    },
    // 平台报表 - 订单消费统计 - 商城菜单统计 - 明细
    getPlatformList: function getPlatformList() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _ref2, order_id, category_id, order_type, _ref3, page, pagesize, params, _yield$orderCategoryD, data, pages, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _ref2 = _this3.originParams || {}, order_id = _ref2.order_id, category_id = _ref2.category_id, order_type = _ref2.type;
              _ref3 = _this3.pages || {}, page = _ref3.page, pagesize = _ref3.pagesize;
              params = {
                order_id: order_id,
                category_id: category_id,
                order_type: order_type,
                page: page,
                pagesize: pagesize,
                view_level: _this3.tabsName
              };
              if (_this3.tabsName === '2') {
                params.province_code = _this3.filter.province_code;
                params.city_code = _this3.filter.city_code;
              }
              _context3.n = 1;
              return orderCategoryDetail(params);
            case 1:
              _yield$orderCategoryD = _context3.v;
              data = _yield$orderCategoryD.data;
              pages = _yield$orderCategoryD.pages;
              _this3.pages.totalCount = (pages === null || pages === void 0 ? void 0 : pages.totalCount) || 0;
              _this3.list = (data === null || data === void 0 ? void 0 : data.list) || [];
              _this3.searchedWithCateName = !!params.province_code || !!params.city_code;
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t2 = _context3.v;
              _this3.list = [];
              _this3.pages.totalCount = 0;
              _this3.searchedWithCateName = false;
              console.log(_t2);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, null, [[0, 2]]);
      }))();
    },
    // 平台报表 - 异常订单监控 - 商城菜单统计 - 明细
    getAbnormalList: function getAbnormalList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _ref4, order_id, category_id, order_type, _ref5, page, pagesize, params, _yield$orderException, data, pages, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              _ref4 = _this4.originParams || {}, order_id = _ref4.order_id, category_id = _ref4.category_id, order_type = _ref4.type;
              _ref5 = _this4.pages || {}, page = _ref5.page, pagesize = _ref5.pagesize;
              params = {
                order_id: order_id,
                category_id: category_id,
                order_type: order_type,
                page: page,
                pagesize: pagesize,
                view_level: _this4.tabsName
              };
              if (_this4.tabsName === '2') {
                params.province_code = _this4.filter.province_code;
                params.city_code = _this4.filter.city_code;
              }
              _context4.n = 1;
              return orderExceptionCategoryDetail(params);
            case 1:
              _yield$orderException = _context4.v;
              data = _yield$orderException.data;
              pages = _yield$orderException.pages;
              _this4.pages.totalCount = (pages === null || pages === void 0 ? void 0 : pages.totalCount) || 0;
              _this4.list = (data === null || data === void 0 ? void 0 : data.list) || [];
              _this4.searchedWithCateName = !!params.province_code || !!params.city_code;
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t3 = _context4.v;
              _this4.list = [];
              _this4.pages.totalCount = 0;
              _this4.searchedWithCateName = false;
              console.log(_t3);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, null, [[0, 2]]);
      }))();
    },
    // 订单列表 - 订单详情 - 商城菜单统计 - 明细(暂与"平台报表-订单消费统计"明细一致，后续可能会有差异)
    getOrderListDetailList: function getOrderListDetailList() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _ref6, order_id, category_id, order_type, _ref7, page, pagesize, params, _yield$orderCategoryD2, data, pages, _t4;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              _ref6 = _this5.originParams || {}, order_id = _ref6.order_id, category_id = _ref6.category_id, order_type = _ref6.type;
              _ref7 = _this5.pages || {}, page = _ref7.page, pagesize = _ref7.pagesize;
              params = {
                order_id: order_id,
                category_id: category_id,
                order_type: order_type,
                page: page,
                pagesize: pagesize,
                view_level: _this5.tabsName
              };
              if (_this5.tabsName === '2') {
                params.province_code = _this5.filter.province_code;
                params.city_code = _this5.filter.city_code;
              }
              _context5.n = 1;
              return orderCategoryDetail(params);
            case 1:
              _yield$orderCategoryD2 = _context5.v;
              data = _yield$orderCategoryD2.data;
              pages = _yield$orderCategoryD2.pages;
              _this5.pages.totalCount = (pages === null || pages === void 0 ? void 0 : pages.totalCount) || 0;
              _this5.list = (data === null || data === void 0 ? void 0 : data.list) || [];
              _this5.searchedWithCateName = !!params.province_code || !!params.city_code;
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t4 = _context5.v;
              _this5.list = [];
              _this5.pages.totalCount = 0;
              _this5.searchedWithCateName = false;
              console.log(_t4);
            case 3:
              return _context5.a(2);
          }
        }, _callee5, null, [[0, 2]]);
      }))();
    }
  }
};